import { replace as replace_1 } from "./fable_modules/fable-library.3.7.20/RegExp.js";

export function replace(pattern, replacement, input) {
    return replace_1(input, pattern, replacement);
}

